import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PageContentComponent } from '../../page-content/page-content.component';
import { AuthorisedSideNavComponent } from '../authorised-side-nav/authorised-side-nav.component';
import { AuthorisedTopNavComponent } from '../authorised-top-nav/authorised-top-nav.component';

@Component({
  selector: 'app-authorised-layout',
  standalone: true,
  imports: [
    CommonModule,
    AuthorisedTopNavComponent,
    AuthorisedSideNavComponent,
    PageContentComponent,
  ],
  templateUrl: './authorised-layout.component.html',
  styleUrls: ['./authorised-layout.component.scss'],
})
export class AuthorisedLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
